import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import businessHelper from "../../helpers/BusinessHelper";
import PerClassTableRow from "../Tables/PerClassTableRow";
import EditPaymentView from "./EditPayementView";
import ResourceApiService from "../../api/resource-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

export default class SalaryEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teacher: this.props.teacher,
            classTypes: this.props.classTypes,
            isLoading: false,
            tableRerenderCount: 0,
            editPaymentInfo: null,
            showClassTypes: true,
            showModal: false,
            updatedSalary: 0,
            inputStarted: 0,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {

    }

    handleChange(event) {
        let newValue = event.target.value;
        const updatedSalary = parseFloat(newValue.replace(/,/g, '-.')) * 100;
        this.setState({updatedSalary: updatedSalary, inputStarted: true})
    }

    render() {
        this.localize();

        return (
            <Card className="shadow">
                {this.state.showModal === true &&
                this.renderModal()
                }
                <CardHeader className="border-0">
                    <Row className="align-items-center">
                        <Col xs="10">
                            <h3 className="mb-0">{resourceStrings.salary_editor}</h3>
                        </Col>
                        <Col xs="2">
                            <div className="modal-header float-right">
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={e => this.props.closeSalaryEditor(e)}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                        </Col>

                        <i className="ml-4 mr-5"> <small>{resourceStrings.salary_expl}</small> </i>
                    </Row>
                </CardHeader>

                <CardBody>
                    <Form>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-salary"
                                                >
                                                    {resourceStrings.formatString(resourceStrings.fixed_salary, businessHelper.currency())}
                                                </label>

                                                <Input
                                                    className="form-control-alternative"
                                                    defaultValue={this.calcFixedSalary()}
                                                    id="input-salary"
                                                    onChange={this.handleChange.bind(this)}
                                                    type="number"
                                                    min={0}
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />

                                                {this.state.inputStarted === true &&
                                                <Button
                                                    className="btn-icon ct-example-tooltip-static mt-4"
                                                    color="warning"
                                                    onClick={e => this.updateTeacher(e)}>

                                                    Save
                                                </Button>
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>

                    <label
                        className="form-control-label"
                        htmlFor="input-start"
                    >
                        {resourceStrings.class_type_payment}
                    </label>

                    <Table
                        className="align-items-center table-dark table-flush"
                        responsive
                    >
                        <thead className="thead-dark">
                        <tr>
                            <th scope="col"/>
                            <th scope="col"/>
                        </tr>
                        </thead>
                        {this.state.showClassTypes &&
                            <tbody>
                            {this.renderTableData()}
                            </tbody>
                        }
                    </Table>
                </CardBody>
            </Card>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    updateTeacher(e) {
        e.preventDefault();

        ResourceApiService.updateTeacher({id: this.state.teacher.id, salary: this.state.updatedSalary})
            .then(res => {
                this.setState({
                    teacher: res,
                    isLoading: false,
                });

                this.props.onTeacherPaymentsUpdated()
            })
            .catch((e) => {
                this.setState({
                    isLoading: false,
                });
                this.props.handleNetworkError(e)
            });
    }


    calcFixedSalary() {
        return ((this.state.teacher.salary || 0) / 100).toFixed(2);
    }

    renderTableData() {
        return this.state.classTypes.map((ct, index) => {
            return (
                <PerClassTableRow paymentInfo={this.makePaymentInfo(ct)}
                                  editPaymentInfo={this.editPaymentInfo.bind(this)}
                                  key={ct.id}
                />
            )
        })
    }

    editPaymentInfo(e, pi) {
        e.preventDefault();

        this.setState({showModal: true, selectedPaymentInfo: pi})
    }

    makePaymentInfo(ct) {
        if (!this.state.teacher.payments) {
            return {className: ct.name, perClass: 0, perStudent: 0, classTypeId: ct.id}
        } else {
            const c = this.state.teacher.payments.find(it => it.class_type_id === ct.id);
            if (!c) {
                return {className: ct.name, perClass: 0, perStudent: 0, classTypeId: ct.id}
            } else {
                return {
                    className: ct.name,
                    perClass: c.class_type_payment || 0,
                    perStudent: c.per_student || 0,
                    classTypeId: ct.id
                }
            }
        }
    }

    toggleModal = state => {
        this.setState({
            showModal: !this.state.showModal
        });
    };

    renderModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showModal}
                toggle={() => this.toggleModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.edit_payments}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditPaymentView
                                updatePaymentInfo={this.updatePaymentInfo.bind(this)}
                                closeEditPaymentView={this.closeEditPaymentView.bind(this)}
                                paymentInfo={this.state.selectedPaymentInfo}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    updatePaymentInfo(e, paymentInfo) {
        this.setState({isLoading: true, showClassTypes: false});

        this.toggleModal();

        const data = {
            ct_id: paymentInfo.classTypeId,
            payment: paymentInfo.perClass,
            per_student: paymentInfo.perStudent,
        };

        ResourceApiService.addTeacherPayment(this.state.teacher.id, data)
            .then(res => {
                this.setState({
                    teacher: res,
                    isLoading: false,
                    showClassTypes: true,
                });

                this.props.onTeacherPaymentsUpdated()
            })
            .catch((e) => {
                this.setState({
                    isLoading: false,
                    showClassTypes: true,
                });
                this.props.handleNetworkError(e)
            });
    }

    closeEditPaymentView() {
        this.toggleModal()
    }
}


SalaryEditor.propTypes = propTypes;